module.exports = __webpack_public_path__ + "static/media/MFN.80b7756f.png";